// packages import
import { yupResolver } from "@hookform/resolvers/yup"
import { Button, CircularProgress, DialogActions } from "@mui/material"
import { FC, useContext } from "react"
import { FormProvider, SubmitHandler, useForm } from "react-hook-form"
// component import
import { Alert } from "../common/Alert"
import { CustomController } from "../common/CustomController"
import { CustomModal } from "../common/CustomModal"
// others
import { CreateTaskInput, TaskType, useCreateTaskMutation } from "../../../generated"
import { CANCEL } from "../../constants"
import { AppContext } from "../../context"
import { ActionType } from "../../context/AppContextReducer"
import { AddNewCustomTaskProps, ErrorException } from "../../interfaceTypes"
import { createCustomTaskValidationSchema } from "../../validationSchema"

export const AddNewCustomTask: FC<AddNewCustomTaskProps> = ({ refetch }) => {
  const { isOpen, dispatch } = useContext(AppContext)

  const methods = useForm<CreateTaskInput>({
    mode: "all",
    resolver: yupResolver(createCustomTaskValidationSchema),

    defaultValues: {
      title: '',
    }
  })

  const { handleSubmit, reset } = methods;

  const [createTaskMutation, { loading }] = useCreateTaskMutation({
    onError({ graphQLErrors }) {
      if (graphQLErrors) {
        graphQLErrors.map(
          // eslint-disable-next-line
          ({ extensions }) => {
            if (extensions) {
              const { exception } = extensions;
              if (exception) {
                const { response } = exception as ErrorException
                const { response: errorResponse } = response || {}
                if (errorResponse) {
                  const { error } = errorResponse
                  Alert.error(error)
                }
              }
            }
          })
      }
    },

    onCompleted(data) {
      if (data) {
        refetch?.()
        Alert.success('Custom Task created successfully')
        handleClose()
        reset()
      }
    }
  })

  const onSubmit: SubmitHandler<CreateTaskInput> = async (data: CreateTaskInput) => {
    const { title } = data

    await createTaskMutation({
      variables: {
        createTaskInput: {
          title,
          type: TaskType.Custom,
        }
      }
    })
  }

  const handleClose = () => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })

  return (
    <CustomModal title='Add Custom Task' isOpen={isOpen} handleClose={handleClose}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
          <CustomController
            controllerName='title'
            controllerLabel='Title'
            fieldType='text'
          />

          <DialogActions sx={{ padding: '30px 0 0' }}>
            <Button onClick={handleClose} variant='outlined' aria-label={CANCEL}>{CANCEL}</Button>

            <Button type="submit" color='primary' variant="contained" disabled={loading} aria-label='add custom task'
              endIcon={loading && <CircularProgress size={20} color="inherit" />}>
              Add Custom Task
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </CustomModal>
  )
}